import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Col, Row } from 'antd';

import { contentOptimizerBriefSubTabKey } from '../../../../../../../constants/contentOptimizer';

import { selectDarkMode } from '../../../../../../../userBrowserSettings/store/browserSettings.selectors';

import { getThemeColorClass } from '../../../../../../../utils/helpers/themeHelpers';

import { briefOutlineTabs } from '../../../contentOptimizerContentConstants';

import ContentBriefOutlineTabs from './ContentBriefOutlineTabs';
import BriefSummaryContainer from './tabsContent/briefSummary/BriefSummaryContainer';
import OutlineOptimizerContainer from './tabsContent/outline/optimizer/OutlineOptimizerContainer';

const classes = {
    briefContent: 'brief-content-wrapper',
};

const BriefTabContent = () => {
    const darkMode = useSelector(selectDarkMode);

    const briefSubTabKey = localStorage.getItem(contentOptimizerBriefSubTabKey);
    const [selectedTab, setSelectedTab] = useState(briefSubTabKey || briefOutlineTabs.brief.key);

    // Automatically redirect a user to correct subtab after a brief or outline is generated.
    useEffect(() => {
        setSelectedTab(briefSubTabKey);
    }, [briefSubTabKey]);

    const onChange = (key) => {
        localStorage.setItem(contentOptimizerBriefSubTabKey, key);
        setSelectedTab(key);
    };

    return (
        <Row className={`${classes.briefContent} ${getThemeColorClass(darkMode)}`}>
            <Col span={17} className='h-100'>
                {selectedTab === briefOutlineTabs.brief.key ? (
                    <BriefSummaryContainer />
                ) : (
                    <OutlineOptimizerContainer />
                )}
            </Col>
            <Col span={7}>
                <ContentBriefOutlineTabs selectedTab={selectedTab} onChange={onChange} />
            </Col>
        </Row>
    );
};

export default BriefTabContent;
